import moduleNameSourceFilesMap from './map';

class DynamicModulesManager {

  constructor() {

    this.loadedModules = {};

  }

  loadSourceFile(sourceFile) {

    return new Promise(function resolver(resolve, reject) {

      var script = document.createElement('script');
      script.src = sourceFile;
      script.type = 'text/javascript';
      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);

      document.getElementsByTagName('head')[0].appendChild(script);

    });

  }

  loadSourceFiles(sourceFiles) {

    const promises = [];

    for (let sourceFile of sourceFiles) {

      promises.push(this.loadSourceFile(sourceFile));

    }

    return Promise.all(promises);

  }

  async loadModule(moduleName) {

    const sourceFiles = moduleNameSourceFilesMap[moduleName];

    if (sourceFiles === void 0) {
      throw new Error(`No source files defined for ${moduleName}`);
    }

    this.loadedModules[moduleName] = this.loadSourceFiles(sourceFiles).then();

    return this.loadedModules[moduleName];

  }

  async load(moduleName) {

    const promise = this.loadedModules[moduleName];

    if (promise !== void 0) {
      return promise;
    }

    return this.loadModule(moduleName);

  }

}

export default DynamicModulesManager;